/* eslint-disable */
import $ from 'jquery';
import backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import pagerTemplate from '@bingads-webui-static-legacy/shared/template/pager.pug';
import config from '@bingads-webui-component-legacy/config/index';
import * as _preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import stateManager from '@bingads-webui-component-legacy/statemanager/campaignStateManager';
import pageContext from '@bingads-webui-static-legacy/page-context';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var preferencesService = _preferencesService.default || _preferencesService;
var pagerView = backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    _.defaults(this.options, {
      template: pagerTemplate,
      id: undefined,
      pageSize: undefined,
      totalCount: undefined,
      pageCount: undefined,
      currentPage: 1,
      refreshTriggers: [],
      enablePageJump: true,
      features: {
        pageSizeSelector: false,
        saveState: true,
        loadState: false
      },
      pageSizes: pageContext.Permissions && pageContext.Permissions.Support500RowsInGrid ? [20, 50, 100, 200, 500] : [20, 50, 100, 200]
    });
    this.options.pageSize = this.options.pageSize || this.options.pageSizes && this.options.pageSizes[0] || 20;
    if (!this.options.totalCount && this.options.features.pageSizeSelector) {
      throw new Error('TotalCount must be specified in order to opt Page Size Selector');
    }
    this._initializeViewModel();
    this._viewModel.value.subscribe(_.bind(this.trigger, this, 'change'));
    this.currentPage = this._viewModel.currentPage;
    this.pageSize = this._viewModel.pageSize;
    this.pageCount = this._viewModel.pageCount;
    this.value = this._viewModel.value;
    this.refresh = _.bind(this._updateViewModel, this, true);
    this.readyPromise = this._initStatePersistence().then(_.bind(function () {
      this._initializeSubscriptions();
      this._initializeLayout();
    }, this));
  },
  destroy: function () {
    ko.cleanNode(this.$el);
    this.$el.empty();
  },
  _initializeLayout: function () {
    var template = _.isFunction(this.options.template) ? this.options.template({
      i18n: i18n,
      features: this.options.features
    }) : this.options.template;
    this.$el.html(template);
    ko.applyBindings(this._viewModel, this.el);
  },
  _initializeViewModel: function () {
    var viewModel = {
      pageSize: ko.observable(),
      totalCount: ko.observable(),
      currentPage: ko.observable(),
      nextPage: _.bind(this._nextPage, this),
      prevPage: _.bind(this._prevPage, this),
      enablePageJump: ko.observable(this.options.enablePageJump),
      features: this.options.features,
      pageSizes: this.options.pageSizes
    };
    viewModel.pageCount = !this.options.totalCount ? ko.observable() : ko.computed(function () {
      return Math.ceil(viewModel.totalCount() / viewModel.pageSize());
    });
    _.extend(viewModel, {
      pages: ko.computed(function () {
        return viewModel.pageCount() >= 1 ? _.range(1, viewModel.pageCount() + 1) : [1];
      }),
      isFirstPage: ko.computed(function () {
        return viewModel.currentPage() == 1;
      }),
      isLastPage: ko.computed(function () {
        return viewModel.currentPage() == viewModel.pageCount();
      }),
      onKeyPress: function (data, event) {
        var keyCode = event.which || event.keyCode;
        if (keyCode === 13) {
          event.target.blur();
          return false;
        }
        return true;
      }
    });
    this._viewModel = viewModel;
    this._updateViewModel(false);
    viewModel.value = ko.observable();
    this._updateValue();
    viewModel.pageSize.subscribe(_.bind(this._updateValue, this));
    viewModel.currentPage.subscribe(_.bind(this._updateValue, this));
  },
  _initializeSubscriptions: function () {
    var self = this;
    _.each(self.options.refreshTriggers, function (trigger) {
      trigger(_.bind(self._updateViewModel, self, true));
    });
  },
  _nextPage: function () {
    if (!this._viewModel.isLastPage()) {
      this._viewModel.currentPage(this._viewModel.currentPage() + 1);
    }
  },
  _prevPage: function () {
    if (!this._viewModel.isFirstPage()) {
      this._viewModel.currentPage(this._viewModel.currentPage() - 1);
    }
  },
  _updateViewModel: function (funcOnly) {
    this._setValue('pageSize', this.options.pageSize, funcOnly);
    this._setValue('totalCount', this.options.totalCount, funcOnly);
    this._setValue('currentPage', this.options.currentPage, funcOnly);
    if (!ko.isComputed(this._viewModel.pageCount)) {
      this._setValue('pageCount', this.options.pageCount, funcOnly);
    }
  },
  _setValue: function (propertyName, valueSource, funcOnly) {
    var oldValue = this._viewModel[propertyName](), newValue = _.isFunction(valueSource) ? valueSource() : valueSource;
    if (!funcOnly || _.isFunction(valueSource)) {
      if (oldValue != newValue) {
        this._viewModel[propertyName](newValue);
      }
    }
  },
  _updateValue: function () {
    var valueObservable = this._viewModel.value;
    var currentPageNumber = decimal.fromLocalToFloat(this._viewModel.currentPage(), 0);
    if (!_.isNumber(this._viewModel.currentPage()) && _.isNumber(currentPageNumber)) {
      this._viewModel.currentPage(currentPageNumber);
    }
    if (!_.isNumber(currentPageNumber) && _.isNumber(valueObservable().currentPage)) {
      this._viewModel.currentPage(valueObservable().currentPage);
    } else if (this._viewModel.pageCount() > 0 && this._viewModel.currentPage() > this._viewModel.pageCount()) {
      this._viewModel.currentPage(this._viewModel.pageCount());
    } else if (this._viewModel.currentPage() < 1) {
      this._viewModel.currentPage(1);
    }
    if (valueObservable() && valueObservable().pageSize == this._viewModel.pageSize() && valueObservable().currentPage == this._viewModel.currentPage()) {
      return;
    }
    valueObservable({
      pageSize: this._viewModel.pageSize(),
      currentPage: this._viewModel.currentPage(),
      skip: (this._viewModel.currentPage() - 1) * this._viewModel.pageSize(),
      take: this._viewModel.pageSize()
    });
  },
  _initStatePersistence: function () {
    var promise;
    if (!this.options.features.loadState) {
      promise = $.Deferred().resolve().promise();
    } else {
      if (!this.options.id) {
        throw new Error('You must specifiy "id" option to use statePersistance');
      }
      promise = this._loadState();
    }
    return promise.then(_.bind(this._initSaveState, this));
  },
  _initSaveState: function () {
    if (!!this.options.id) {
      this._viewModel.pageSize.subscribe(_.bind(function (newValue) {
        var IsUsePreferencesServiceEnabled = _.result(config.get('permissions'), 'IsUsePreferencesServiceEnabled');
        if (IsUsePreferencesServiceEnabled) {
          preferencesService.setAtUserLevel({
            Name: 'WebApp.CampaignUI.pager_' + this.options.id,
            Data: {
              pageSize: newValue
            }
          });
        } else {
          stateManager.setItem('permanent', 'pager_' + this.options.id, {
            pageSize: newValue
          });
        }
      }, this));
    }
  },
  _loadState: function () {
    var IsUsePreferencesServiceEnabled = _.result(config.get('permissions'), 'IsUsePreferencesServiceEnabled');
    if (IsUsePreferencesServiceEnabled) {
      return preferencesService.initialize().then(_.bind(function () {
        var preference = preferencesService.findByName('WebApp.CampaignUI.pager_' + this.options.id) || ({});
        if (preference.Data && preference.Data.pageSize) {
          this._viewModel.pageSize(preference.Data.pageSize);
        }
      }, this));
    } else {
      return stateManager.getItem('pager_' + this.options.id).then(_.bind(function (value) {
        if (value.permanent.pageSize) {
          this._viewModel.pageSize(value.permanent.pageSize);
        }
      }, this));
    }
  }
});
export default pagerView;

